module.exports = __webpack_public_path__ + "static/media/supportIcon.2b9a308e.svg";